<template>
  <div>
    <!-- eslint-disable  -->
    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <g id="Icons">
        <path d="M31,34a3,3,0,1,0-3-3A3.009,3.009,0,0,0,31,34Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,31,30Z" style="fill:none"/>
        <path d="M24,20a4,4,0,1,0,4,4A4,4,0,0,0,24,20Zm0,6a2,2,0,1,1,2-2A2.006,2.006,0,0,1,24,26Z" style="fill:none"/>
        <path d="M32,24a3,3,0,1,0-3-3A3.009,3.009,0,0,0,32,24Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,32,20Z" style="fill:none"/>
        <path d="M20,29a3,3,0,1,0,3,3A3.009,3.009,0,0,0,20,29Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,20,33Z" style="fill:none"/>
        <path d="M41,31a3,3,0,1,0,3-3A3.009,3.009,0,0,0,41,31Zm4,0a1,1,0,1,1-1-1A1,1,0,0,1,45,31Z" style="fill:none"/>
        <path d="M40,28a4,4,0,1,0-4-4A4,4,0,0,0,40,28Zm0-6a2,2,0,1,1-2,2A2.006,2.006,0,0,1,40,22Z" style="fill:none"/>
        <path d="M44,39a5,5,0,1,0-5,5A5,5,0,0,0,44,39Zm-5,3a3,3,0,1,1,3-3A3.009,3.009,0,0,1,39,42Z" style="fill:none"/>
        <path d="M31,41a3,3,0,1,0,3,3A3.009,3.009,0,0,0,31,41Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,31,45Z" style="fill:none"/>
        <circle cx="20" cy="32" r="1" class="corona-body corona-body--filled" />
        <circle cx="31" cy="44" r="1" class="corona-body corona-body--filled" />
        <circle cx="32" cy="21" r="1" class="corona-body corona-body--filled" />
        <circle cx="40" cy="24" r="2" class="corona-body corona-body--filled" />
        <circle cx="24" cy="24" r="2" class="corona-body corona-body--filled" />
        <circle cx="39" cy="39" r="3" class="corona-body corona-body--filled" />
        <circle cx="44" cy="31" r="1" class="corona-body corona-body--filled" />
        <circle cx="31" cy="31" r="1" class="corona-body corona-body--filled" />
        <circle cx="23" cy="40" r="2" class="corona-body corona-body--filled" />
        <path class="corona-tail" ref="tail1" d="M28.87,8.21c.62-.09,1.33-.15,2.14-.19.34-.01.67-.02.99-.02s.65.01.97.02c.83.04,1.53.1,2.16.19a22.7,22.7,0,0,1,1.78-5.79,1,1,0,0,0-.44-1.3,9.48,9.48,0,0,0-8.94,0,1,1,0,0,0-.44,1.3A22.7,22.7,0,0,1,28.87,8.21Z"/>
        <path class="corona-tail" ref="tail2" d="M42.01,16.84a1.011,1.011,0,0,0,.28.87l4,4A1.007,1.007,0,0,0,47,22a.86.86,0,0,0,.16-.01,1.025,1.025,0,0,0,.74-.55,15.493,15.493,0,0,1,11.27-8.45,1.021,1.021,0,0,0,.73-.56,1.006,1.006,0,0,0-.02-.91,18.639,18.639,0,0,0-7.4-7.4,1.006,1.006,0,0,0-.91-.02,1.021,1.021,0,0,0-.56.73A15.569,15.569,0,0,1,48.2,11.4a15.6,15.6,0,0,1-5.64,4.7A1.025,1.025,0,0,0,42.01,16.84Z"/>
        <path class="corona-tail" ref="tail3" d="M62.88,27.53a1,1,0,0,0-1.3-.44,22.7,22.7,0,0,1-5.79,1.78c.09.62.15,1.33.19,2.14.01.34.02.67.02.99s-.01.65-.02.97c-.04.83-.1,1.53-.19,2.16a22.7,22.7,0,0,1,5.79,1.78A1.059,1.059,0,0,0,62,37a.988.988,0,0,0,.88-.53,9.48,9.48,0,0,0,0-8.94Z"/>
        <path class="corona-tail" ref="tail4" d="M59.17,51.01A15.493,15.493,0,0,1,47.9,42.56a1.025,1.025,0,0,0-.74-.55,1,1,0,0,0-.87.28l-4,4a1.011,1.011,0,0,0-.28.87,1.025,1.025,0,0,0,.55.74,15.493,15.493,0,0,1,8.45,11.27,1.021,1.021,0,0,0,.56.73A.907.907,0,0,0,52,60a1,1,0,0,0,.48-.12,18.639,18.639,0,0,0,7.4-7.4,1.006,1.006,0,0,0,.02-.91A1.021,1.021,0,0,0,59.17,51.01Z"/>
        <path class="corona-tail" ref="tail5" d="M35.13,55.79c-.62.09-1.33.15-2.14.19-.34.01-.67.02-.99.02s-.65-.01-.97-.02c-.83-.04-1.53-.1-2.16-.19a22.7,22.7,0,0,1-1.78,5.79,1,1,0,0,0,.44,1.3,9.48,9.48,0,0,0,8.94,0,1,1,0,0,0,.44-1.3A22.7,22.7,0,0,1,35.13,55.79Z"/>
        <path class="corona-tail" ref="tail6" d="M21.99,47.16a1.011,1.011,0,0,0-.28-.87l-4-4a1.011,1.011,0,0,0-.87-.28,1.025,1.025,0,0,0-.74.55,15.6,15.6,0,0,1-4.7,5.64,15.569,15.569,0,0,1-6.57,2.81,1.021,1.021,0,0,0-.73.56,1.006,1.006,0,0,0,.02.91,18.639,18.639,0,0,0,7.4,7.4A1,1,0,0,0,12,60a.907.907,0,0,0,.43-.1,1.021,1.021,0,0,0,.56-.73A15.493,15.493,0,0,1,21.44,47.9,1.025,1.025,0,0,0,21.99,47.16Z"/>
        <path class="corona-tail" ref="tail7" d="M8.02,32.99C8.01,32.65,8,32.32,8,32s.01-.65.02-.97c.04-.83.1-1.53.19-2.16a22.7,22.7,0,0,1-5.79-1.78,1,1,0,0,0-1.3.44,9.48,9.48,0,0,0,0,8.94A.988.988,0,0,0,2,37a1.059,1.059,0,0,0,.42-.09,22.7,22.7,0,0,1,5.79-1.78C8.12,34.51,8.06,33.8,8.02,32.99Z"/>
        <path class="corona-tail" ref="tail8" d="M4.83,12.99A15.569,15.569,0,0,1,11.4,15.8a15.6,15.6,0,0,1,4.7,5.64,1.025,1.025,0,0,0,.74.55A.86.86,0,0,0,17,22a1.007,1.007,0,0,0,.71-.29l4-4a1.011,1.011,0,0,0,.28-.87,1.025,1.025,0,0,0-.55-.74,15.6,15.6,0,0,1-5.64-4.7,15.569,15.569,0,0,1-2.81-6.57,1.021,1.021,0,0,0-.56-.73,1.006,1.006,0,0,0-.91.02,18.639,18.639,0,0,0-7.4,7.4,1.006,1.006,0,0,0-.02.91A1.021,1.021,0,0,0,4.83,12.99Z"/>
        <path class="corona-body" ref="body" d="M40.04,47.53a3.029,3.029,0,0,1,.84-2.65l4-4A2.956,2.956,0,0,1,47,40a3.829,3.829,0,0,1,.47.03,3.067,3.067,0,0,1,2.23,1.66,13.568,13.568,0,0,0,1.06,1.79,21.923,21.923,0,0,0,3.05-8.59c.09-.65.14-1.32.17-1.99.01-.3.02-.6.02-.9s-.01-.6-.02-.9c-.03-.67-.08-1.34-.17-1.99a21.923,21.923,0,0,0-3.05-8.59,13,13,0,0,0-1.06,1.8A2.938,2.938,0,0,1,47,24a3,3,0,0,1-2.12-.88l-4-4a2.977,2.977,0,0,1-.84-2.6,3.032,3.032,0,0,1,1.65-2.22,13.568,13.568,0,0,0,1.79-1.06,21.923,21.923,0,0,0-8.59-3.05c-.65-.09-1.32-.14-1.99-.17-.3-.01-.6-.02-.9-.02s-.6.01-.9.02c-.67.03-1.34.08-1.99.17a21.923,21.923,0,0,0-8.59,3.05,13,13,0,0,0,1.8,1.06,2.995,2.995,0,0,1,.8,4.82l-4,4A3,3,0,0,1,17,24a2.469,2.469,0,0,1-.54-.05,3.006,3.006,0,0,1-2.16-1.64,13.568,13.568,0,0,0-1.06-1.79,21.923,21.923,0,0,0-3.05,8.59c-.09.65-.14,1.32-.17,1.99-.01.3-.02.6-.02.9s.01.6.02.9c.03.67.08,1.34.17,1.99a21.923,21.923,0,0,0,3.05,8.59,13,13,0,0,0,1.06-1.8,3.054,3.054,0,0,1,2.17-1.64A3.586,3.586,0,0,1,17,40a3,3,0,0,1,2.09.85A3.886,3.886,0,0,1,19,40a4,4,0,1,1,4,4,3.953,3.953,0,0,1-.85-.09l.97.97a2.977,2.977,0,0,1,.84,2.6,3.032,3.032,0,0,1-1.65,2.22,13.568,13.568,0,0,0-1.79,1.06,21.923,21.923,0,0,0,8.59,3.05c.65.09,1.32.14,1.99.17.3.01.6.02.9.02s.6-.01.9-.02c.67-.03,1.34-.08,1.99-.17a21.923,21.923,0,0,0,8.59-3.05,13,13,0,0,0-1.8-1.06A3.054,3.054,0,0,1,40.04,47.53ZM47,31a3,3,0,1,1-3-3A3.009,3.009,0,0,1,47,31ZM40,20a4,4,0,1,1-4,4A4,4,0,0,1,40,20Zm-8-2a3,3,0,1,1-3,3A3.009,3.009,0,0,1,32,18ZM31,28a3,3,0,1,1-3,3A3.009,3.009,0,0,1,31,28ZM20,35a3,3,0,1,1,3-3A3.009,3.009,0,0,1,20,35Zm4-7a4,4,0,1,1,4-4A4,4,0,0,1,24,28Zm7,19a3,3,0,1,1,3-3A3.009,3.009,0,0,1,31,47Zm3-8a5,5,0,1,1,5,5A5,5,0,0,1,34,39Z"/>
      </g>
    </svg>
  </div>

</template>

<script>
const TAILS_COUNT = 8;

export default {
  name: 'CoronaIcon',
  props: {
    complete: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.fillIcon(this.complete);
  },
  methods: {
    fillIcon(percent = 40) {
      const filledTails = Math.round((TAILS_COUNT * percent) / 100);
      if (percent === 0) {
        this.$refs.body.classList.add('corona-body--empty');
        this.fillTails(TAILS_COUNT, 'corona-tail--empty');
        return;
      }
      this.fillTails(filledTails, 'corona-tail--filled');
      if (percent === 100) this.$refs.body.classList.add('corona-body--filled');
    },
    fillTails(tailsCount, cssClass) {
      for (let i = 1; i <= tailsCount; i += 1) {
        this.$refs[`tail${i}`].classList.add(cssClass);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  svg {
    width: 50px;
    margin: 6px;

    &:hover {
      .corona-tail {
        transform: scale(1.1);
      }
    }
  }

  .corona-tail {
    fill: #eeee00;
    transform-origin: center;
    transition: transform .3s;

    &--empty {
      fill: var(--v-error-base);
    }

    &--filled {
      fill: var(--v-success-base);
    }
  }

  .corona-body {
    /*fill: var(--v-warning-lighten3);*/
    fill: #eeee00;

    &--empty {
      fill: var(--v-error-base);
    }

    &--filled {
      fill: var(--v-success-base);
    }
  }

</style>
